// extracted by mini-css-extract-plugin
module.exports = {"root":"caDVC","avatar":"_37X9S"};